import {SubstitutionResponse, SubstitutionResponseItem } from '@/types/service-response'

export class Substitution {
  public constructor (
    readonly fullName: string,
    readonly shortName: string,
    readonly employeeId: number,
    readonly personalNumber: string,
    readonly addressName: string,
    readonly addressNumber: string,
    readonly dateTo: string,
    readonly dateFrom: string,
    readonly absenceReason: number,
    readonly nextAction: string,
    readonly projectNumber: string,
    readonly date: string,
    readonly rowId: number,
    readonly STVFullName: string,
    readonly STVShortName: string,
    readonly STVEmployeeId: number,
    readonly STVPersonalNumber: string,
    readonly STVSpecification: string,
    readonly email: string,
    readonly phone: string,
    readonly deleted: number | null,
    readonly groupLabel: string,
    readonly addressLabel: string,
    public isChecked: boolean
  ) {}

  static createFromResponse (responseData: SubstitutionResponse): Array<Substitution> {
    let result: Array<Substitution> = []
    if (responseData) {
      result = responseData.map((item: SubstitutionResponseItem ) => {
        const groupLabel: string = `${item.Kurzzeichen} / ${item.FullName} (${item.PersonalNummer})`
        const addressLabel: string = `${item.AdressNummer} ${item.AdressLinie}`
        return new Substitution(
          item.FullName,
          item.Kurzzeichen,
          item.MitarbeiterID,
          item.PersonalNummer,
          item.AdressLinie,
          item.AdressNummer,
          item.DatumBis,
          item.DatumVon,
          item.Grund,
          item.NSchritt,
          item.ProjektNummer,
          item.ReferenzTermin,
          item.RowID,
          item.STVFullName,
          item.STVKurzzeichen,
          item.STVMitarbeiterID,
          item.STVPersonalNummer,
          item.STVVorgabe,
          item.M_Email,
          item.M_Phone,
          item.Deleted,
          groupLabel,
          addressLabel,
          false
        )
      })
    }
    return result
  }
}
